<template>
  <div :id="id" :class="wrapperClasses">
    <div class="container mx-auto flex max-w-screen-xl flex-col items-center justify-between md:flex-row">
      <div class="mb-4 flex w-full flex-col md:mb-0 md:w-1/2" :class="textColor ? textColor : 'text-white'">
        <div v-t="$cfg.newsletterTitle" class="whitespace-nowrap text-3xl font-extrabold"></div>
        <div class="text-base font-medium leading-tight" v-html="$cfg.newsletterSubtitle"></div>
      </div>

      <div class="flex w-full md:w-1/2">
        <VcInput class="grow" no-border :placeholder="$cfg.newsletterPlaceholder" />
        <VcButton v-t="$cfg.newsletterButton" size="sm" class="ml-4 px-6"> {{ $cfg.newsletterButton }}</VcButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { VcButton } from "@/ui-kit/components";

interface IProps {
  id: string;
  background?: string;
  textColor?: string;
  bottomMargin?: string;
  verticalPadding?: string;
}

const props = defineProps<IProps>();

const wrapperClasses = computed(() => {
  return [
    props.background ? props.background : "",
    props.bottomMargin ? props.bottomMargin : "my-0",
    props.verticalPadding ? props.verticalPadding : "py-5 lg:py-10",
  ];
});
</script>
